import { useMy } from '@/hooks';
import { AddSeedByTypeModal } from '@/sections/seeds/components/modals/AddSeedByTypeModal';
import { StorageKey, useStorage } from '@/utils/storage/useStorage.util';

/**
 * First-run onboarding for zero-asset new users: surfaces the standard
 * AddSeedByTypeModal wizard (intro → type → seeds → optional credentials)
 * instead of a bespoke single-input form. The gate is unchanged — it opens
 * once for a new user with no assets while the
 * `StorageKey.SHOW_NEW_USER_SEED_MODAL` flag is set, then flips the flag on
 * close so it never reappears. Mounted in `AuthenticatedApp`.
 */
export const NewUserSeedModal = () => {
  const { data: assets = [], status } = useMy({
    resource: 'asset',
  });

  const [newUserSeedModal, setNewUserSeedModal] = useStorage(
    { key: StorageKey.SHOW_NEW_USER_SEED_MODAL },
    false
  );

  // Derived open state — no effect/setState needed. Closing flips the flag,
  // which durably drops `open` to false so the wizard never reappears.
  const open = status === 'success' && assets.length === 0 && newUserSeedModal;

  function handleClose() {
    setNewUserSeedModal(false);
  }

  return (
    <AddSeedByTypeModal
      open={open}
      onClose={handleClose}
      onSuccess={handleClose}
    />
  );
};
